<template>
  <div
    class="spotMonitor gridLayout"
    style="height: 46px; display: flex; align-items: center"
  >
    <div class="ml20">{{ factorInfo.title }}</div>
    <el-tabs
      class="ml30"
      @tab-click="changeRoute(activeName)"
      v-model="activeName"
      style="margin-top: 7px"
    >
      <el-tab-pane
        :label="isBeidouSpecialCode ? $t('应用数据') : $t('测点曲线')"
        name="spotMonitor"
      ></el-tab-pane>
      <el-tab-pane
        :label="isBeidouSpecialCode ? $t('解算数据') : $t('原始数据')"
        name="deviceMonitor"
      ></el-tab-pane>
      <el-tab-pane
        v-if="['vibration', 'dynamic'].includes(factorInfo.specialCode)"
        :label="$t('振动曲线')"
        name="vibrationMonitor"
      ></el-tab-pane>
      <el-tab-pane
        v-if="isBeidouSpecialCode"
        :label="$t('北斗信息')"
        name="beidouMonitor"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      factorInfo: {},
      isBeidouSpecialCode: false,
      activeName: "",
    };
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters(["secondRouters", "buttonPageObj"]),
  },
  watch: {
    $route: {
      handler() {
        this.$store.commit("SET_FACTORINFO", {});
        if (this.$route.path.includes("/factorInfo")) {
          let factorInfo = this.getFactorInfo(this.$route.path);
          if (factorInfo && !factorInfo.path.includes(this.activeName)) {
            this.$router.push({
              path: this.getLink(factorInfo, this.activeName),
            });
          }
        }
      },
      deep: true,
      immediate: true,
    },
    secondRouters() {
      if (this.$route.path.includes("/factorInfo")) {
        let factorInfo = this.getFactorInfo(this.$route.path);
        if (factorInfo) {
          this.$router.push({
            path: this.getLink(factorInfo, this.activeName),
          });
        }
      }
    },
  },
  methods: {
    changeRoute(activeName) {
      let path = this.getLink(this.factorInfo, activeName);
      if (path != this.$route.path) {
        this.$router.push({ path: path });
      }
    },
    getFactorInfo(path) {
      path = path || "";
      let secondRouters = this.secondRouters;
      if (!secondRouters.length) {
        return;
      }
      let routePath = path.split("/"),
        len = routePath.length;
      let factorId = routePath[len - 2],
        groupId = routePath[len - 1],
        activeName = routePath[len - 3];
      let factorInfo = secondRouters.find((item) => item.id == factorId);
      if (factorInfo) {
        if (factorInfo.children.length) {
          groupId = groupId == "noGroup" ? factorInfo.children[0].id : groupId;
          let specialCode = factorInfo.specialCode;
          // 分组的specialCode以父节点的为准
          factorInfo = factorInfo.children.find((item) => item.id == groupId);
          factorInfo.specialCode = specialCode;
        }
      } else {
        let secondRouters = this.secondRouters;
        if (secondRouters[0].children.length) {
          factorInfo = secondRouters[0].children[0];
          factorInfo.specialCode = secondRouters[0].specialCode;
        } else {
          factorInfo = secondRouters[0];
        }
      }
      this.factorInfo = factorInfo;
      // 设置全局store
      this.$store.commit("SET_FACTORINFO", factorInfo);
      // 是否为北斗
      let specialCode = factorInfo.specialCode;
      this.isBeidouSpecialCode =
        specialCode == "three_dimensional_displacement" ? true : false;

      // 如果没有权限跳转到测点监控
      if (
        (activeName == "vibrationMonitor" &&
          !this.buttonPageObj["monitorInfo.vibration"]) ||
        (activeName == "beidouMonitor" &&
          !this.buttonPageObj["monitorInfo.beidouInformation"])
      ) {
        activeName = "spotMonitor";
      }
      if (
        !this.activeName ||
        ["deviceMonitor", "beidouMonitor"].includes(activeName)
      ) {
        this.activeName = activeName;
      }
      return factorInfo;
    },
    getLink(item, activeName) {
      console.log(item, activeName, "==========99");
      if (
        ["three_dimensional_displacement"].includes(item.specialCode) &&
        ["beidouMonitor"].includes(activeName)
      ) {
        this.activeName = activeName;
        return item.path;
      } else {
        let routePath = item.path.split("/"),
          len = routePath.length;
        let factorId = routePath[len - 2],
          groupId = routePath[len - 1] || "noGroup";
        this.activeName = "spotMonitor";
        if (activeName == "deviceMonitor") {
          this.activeName = "deviceMonitor";
        } else if (
          activeName == "vibrationMonitor" &&
          ["vibration", "dynamic"].includes(item.specialCode)
        ) {
          this.activeName = "vibrationMonitor";
        } else if (activeName == "resultMonitor") {
          this.activeName = "resultMonitor";
        }
        return `/platform/factorInfo/${this.activeName}/${factorId}/${groupId}`;
      }
    },
  },
};
</script>
